import React from 'react'
import { useDispatch } from 'react-redux'
import { moduleContext } from 'react-contextual'
import { events } from './state'
import { TPropertyCreateRequest } from './types'

type TPropertyApiProviderProps = {
  context: React.Context<unknown>
  children?: React.ReactNode
}

const PropertyApiProvider = moduleContext()(({ context, children }: TPropertyApiProviderProps) => {
  const dispatch = useDispatch()
  const store = {
    createProperty: (payload: TPropertyCreateRequest) => dispatch(events.createProperty_request(payload)),
    fetchProperties: () => dispatch(events.properties_request()),
    fetchSearchResults: (query: string) => dispatch(events.search_request({ query })),
    fetchCombinedSearchResults: (query: string) => dispatch(events.combinedSearch_request({ query })),
    fetchGooglePlace: (placeId: string) => dispatch(events.place_request({ placeId })),
    fetchProperty: (id: string) => dispatch(events.property_request({ id })),
  }

  return <context.Provider value={store}>{children}</context.Provider>
})

export default PropertyApiProvider
